export interface CaseInfo {
  bid?: string;
  branchName: string;
  caseno: string;
  iidx: number;
  itemno: string;
  lidx: number;
  saleDate: string;
  type: string;
  viewgray2: string;
  iaddr?: string;
  iaddr2?: string;
  roadnamelocation?: string;
  date: {
    div_date: string;
    remaining_days: number | null;
    saledate: string;
    start_date: string;
  };
}

export interface HouseInfoProps {
  approvaldate: string;
  basementfloornum: number;
  buildingtolandratio: number;
  created_year: string;
  createddate: string;
  floorarearatio: number;
  groundfloornum: number;
  ledgercodename: string;
  ledgertypecodename: string;
  mainpurposecodename: string;
  old_year: number;
  otheruses: string;
  roadnamelocation: string;
  structurecodename: string;
  totalfloorarea: number;
  totalfloorpyeong: number;
  upperhousekey: null | string;
}

export interface LandInfoProprs {
  address: string;
  area: number;
  category: string;
  height: string;
  pyeong: number;
  rate?: number;
  roadsurface: string;
  shape: string;
  usestatus: string;
  zoning_backup: string;
  bcr_rate: number;
  far_rate: number;
  roadsurface_desc: string;
  pnu?: string;
}

export interface SaleInfoProps {
  data: string;
  minprice: string;
  no: string;
  result: string;
}

export interface TotalSaleList {
  landAreaPyeong: number;
  landAreaMeter: number;
  buildingAreaPyeong: number;
  buildingAreaMeter: number;
  etcAreaPyeong: number;
  etcAreaMeter: number;
  appraisalPrice: number;
  salePrice: number;
  landPrice: number;
  buildingPrice: number;
  etcPrice: number;
  machinePrice: number;
}

export interface Renter {
  confirmedDate: string;
  deposit: string;
  infoSource: string;
  monthlyRentPay: string;
  occupyYN: string;
  regDate: string;
  rentPeriod: string;
  renter: string;
  rpart: string;
  rtype: string;
  cov_deposit: string;
}

export interface HighlightData {
  hilight: {
    loanSale: LoanSaleItem[];
    aquire: AquireItem[];
    both: BothItem[];
  };
}
export interface LoanSaleItem {
  expecteddPrice: number;
  salePrice: number;
  purchasePrice: number;
  loanSaleEarning: number;
  roi: number;
  roe: number;
}

export interface AquireItem {
  expecteddPrice: number;
  winningBidPrice: number;
  interestCost: number;
  surcharge: number;
  expectedIncome: number;
  roi: number;
  roe: number;
}

export interface BothItem {
  expecteddPrice: number;
  salePrice: number;
  purchasePrice: number;
  auctionfee: number;
  expectedIncome: number;
  roi: number;
  roe: number;
}
export interface CompareData {
  ComprehensiveComparison: {
    note: {
      '1': string;
      '2': string;
      '3': string;
      '4': string;
    }[];
    loansale: {
      diviendPrice: number;
      purchaseLoanPrice: number;
      salePrice: number;
      divendEarning: number;
      roi: number;
      roe: number;
    }[];
    acquire: {
      diviendPrice: number;
      purchaseLoanPrice: number;
      interestCost: number;
      surcharge: number;
      expectedIncome: number;
      roi: number;
      roe: number;
    }[];
    both: {
      diviendPrice: number;
      purchaseLoanPrice: number;
      purchasePrice: number;
      auctionFee: number;
      expectedIncome: number;
      roi: number;
      roe: number;
    }[];
  };
}
export interface DiscountRate {
  dividendPrice: number;
  purchaseLoanPrice: number;
  orirate: number;
  originalLoanPrice: number;
  discountrate: number;
  keyMoney: number;
  keydiscountrate: number;
}

export interface PurchaseLoan {
  totalPrice: number;
  capitalPrice: number;
  crate: number;
  plendgePrice: number;
  prate: number;
  MonthlyplendgeInterestAmount: number;
  pInterestRate: number;
  investMonth: number;
  totalInterestAmount: number;
  transferCost: number;
  trate: number;
  advancePayment: number;
  arate: number;
}

export interface Income {
  expecteddIncome: number;
  roi: number;
  roiyearlyIncomeRate: number;
  roe: number;
  roeYearlyIncomeRate: number;
}

export interface LoanSale {
  discountRate: DiscountRate[];
  purcharseLoan: PurchaseLoan[];
  Income: Income[];
}

export interface DividendData {
  loanSale: LoanSale;
}
export interface DividendInflowData {
  both: {
    income: {
      expectedPrice: number;
      surroundAveragePersalePrice: number;
      purchaseLoanPrice: number;
      purchaseLoanPricePerOriLoan: number;
      capital: number;
      capitalPerPurchasePrice: number;
      plendgeLoan: number;
      plendgeLoanPerPurchasePrice: number;
      purchaseLoantotalCost: number;
      totalAuctionAndSaleCost: number;
      expectedIncome: number;
      roi: number;
      roiannualizedYield: number;
      roe: number;
      roeannualizedYield: number;
    }[];
  };
}

export interface Note {
  '1': string;
  '2': string;
}

export interface PossibleDividendPrice {
  possibleDiviendPrice: number;
  salePrice: number;
  auctionPrice: number;
  rate: number;
}

export interface DividendTable {
  no: number;
  creditor: string;
  debtAmount: number;
  maxadebtAmount: number;
  dividendPrice: number;
  restPrice: number;
}

export interface Dividend {
  note: Note[];
  possibleDividendPrice: PossibleDividendPrice[];
  dividendTable: DividendTable[];
}

export interface DividendableAmountData {
  dividend: Dividend;
}

export interface AcquireNote {
  '1': string;
  '2': string;
  '3': string;
  '4': string;
}

export interface SaleAmount {
  expecteddPrice: number;
  surAvgrate: number;
  winningBidPrice: number;
  mycapital: number;
  capitalPerbidPrice: number;
  plendgeCapital: number;
  plendgePerbidPrice: number;
}

export interface BidCost {
  monthlyInterest: number;
  interestRate: number;
  investMonth: number;
  totalInterest: number;
  acquisitionTax: number;
  acquisitionTaxPerAuctionAmount: number;
  legalFee: number;
  legalFeePerAuctionAmount: number;
  moveCost: number;
  moveCostPerAuctionAmount: number;
  delayCost: number;
  delayCostPerAuctionAmount: number;
  unpaidAmount: number;
  utilityFee: number;
  commision: number;
  commisionPerAuctionAmount: number;
}

export interface Income {
  expecteddIncome: number;
  roi: number;
  roiAnnualizedYield: number;
  roe: number;
  roeAnnualizedYield: number;
}

export interface Acquire {
  note: AcquireNote[];
  saleAmount: SaleAmount[];
  bidCost: BidCost[];
  income: Income[];
}

export interface InflowInvestmentData {
  acquire: Acquire;
}

export interface BondSuccessfulBidData {
  loanAmountandWinningBid: {
    loanAmount: {
      maxDebtAmount: number;
      oriDebtAmount: number;
      rate: number;
    };
    winningBid: {
      expecteddPrice: number;
      list: {
        no: number;
        expecteddPrice: number;
        type: any;
        saleRate: number;
      }[];
    };
  };
}

export interface LoanInfoDetail {
  caseno: string;
  mainAddress: string;
  maxDebtAmount: number;
  totalAppraisalPrice: number;
  manager: string;
  courtName: string;
  courtcode: number;
  claimAmount: number;
  totalMinprice: number;
  hopesaleprice: number;
  loanAppraisalPrice: number;
}

export interface ItemDescription {
  itmeno: number;
  mainAddr: string;
  itemInfo: string[];
  state: string;
  minprice: number;
  appraisalPrice: number;
}

export interface LoanInfo {
  loanInfo: LoanInfoDetail[];
  itemDescription: ItemDescription[];
}

export interface NplBasicInfoData {
  caseInfo: CaseInfo;
  loanInfo: LoanInfo;
}

export interface BasicInfoProps {
  address: string;
  appraisalPrice: number;
  assetClass?: string;
  bidCount?: string;
  bidMethod?: string;
  bidPrice: string;
  biddate?: string;
  buildingArea: number;
  buildingAreaPyoeng: number;
  category: string;
  claimAmount: number;
  courtName: string;
  courtRegion: string;
  creditor: string;
  debtor: string;
  department: string;
  landArea: number;
  landAreaPyoeng: number;
  manager: string;
  maxDebtAmount: number;
  minimumPrice: number;
  minimumPricePerAppraisalPrice: number;
  owner: string;
  saleItem: string;
  appraisalData: string
}

export interface RealDealDataItem {
  dealdate: string;
  dealprice: string;
  dealprice2: number;
  distance: number;
  price_per_pyeong: number;
  pyeong: number;
  type: string;
  floor: number;
  region?: string;
  legaldong?: string;
}

export interface RealDealData {
  jeonse: RealDealDataItem[];
  jeonse_total: string;
  monthly: RealDealDataItem[];
  monthly_total: string;
  sale: RealDealDataItem[];
  jeonse_summary: RealDealDataItem[];
  sale_summary: RealDealDataItem[];
  sale_total: string;
  ptype: string;
  ptype2: string;
}

export interface priceAnalysisProps {
  appraisedPrc_meter: number | string;
  appraisedPrc_pyeong: number;
  avgPrc_high_meter: number;
  avgPrc_high_pyeong: number;
  avgPrc_low_meter: number;
  avgPrc_low_pyeong: number;
  avgPrc_meter: number;
  avgPrc_pyeong: number;
  minPrc_meter: number | string;
  minPrc_pyeong: number;
}

export interface LinkData {
  buttonLink: {
    appraisal: string;
    assetDetail: string;
    buildingRegister: string;
    documentsHistory: string;
    landRegister: string;
    propertyStat: string;
    statusSurvey: string;
    
  };
  detailLink: {
    url: string;
    url1: string;
    url2: string;
  };
  eumMapLink: string;
  landUsePlanLink: string;
  serialLink: string;
}

export interface ExtendedLinkData extends LinkData {
  url4?: {
    content: string;
    link: string;
  }[];
}

export const saleNotesData = [
  { text: '일괄매각. 제시외 건물 포함' },
  {
    text: '농지취득자격증명원 제출요',
    description:
      '미제출시 보증금 몰수, 농지법 등 개정으로 농지취득자격증명서의 발급기간이 연장되었으니, 관할 관청에 발급 여부를 확인 후 입찰요망, 전용허가 없이 토지현황 변경된 경우 향후 원상회복명령 발하여질 가능성 있음',
  },
  {
    text: '파쇄석, 대리석, 잔디등은 토지감정평가액에 포함됨. 나무데크의 경우 철거에 용이하여 제외.',
  },
  {
    text: `목록 3~7의 공부상 지목은 "답,전 및 임야"이나 현황 "잡종지 및 이행지 등"으로 이용중임.`,
  },
];

export const propertyStatusData = [
  {
    text: `제시외(소유자 (주)피제이엠 소유 및 점유)
          2번 목록 지상에 
          (1). 각파이프조 발코니(1번 목록에 접하여 소재함)
          -. 현황 2번, 3번, 5번, 6번은 지상으로 고압선이 지나는 선하지임.(생략) …`,
  },
];

export interface AppraisalItem {
  text: string;
}

export const appraisalData: AppraisalItem[] = [
  { text: '위치 및 주의환경' },
  {
    text: '교통 상황',
  },
  {
    text: '형태 및 이용상태',
  },
  {
    text: '인접 도로 상태',
  },
  {
    text: '토지이용계획 및 제한상태',
  },
  {
    text: '제시목록 외 물건',
  },
  {
    text: '공부와의 차이',
  },
  {
    text: '기타 참고사항 (임대관례 및 기타)',
  },
];

export const TenantInfo = [
  {
    name: '(주)피제이엠 대표 장영아',
    occupancy: '?',
    leasePeriod: '?',
    applicationDate: '2019.11.15',
    informationSource: '현황조사',
    deposit: '?',
    confirmationDate: '미상',
    occupancyRights: '점포 임차인',
    rent: '?',
    dividendDemand: '?',
  },
  {
    name: '박종현',
    occupancy: '?',
    leasePeriod: '?',
    applicationDate: '2019.11.15',
    informationSource: '현황조사',
    deposit: '?',
    confirmationDate: '미상',
    occupancyRights: '점포 임차인',
    rent: '?',
    dividendDemand: '?',
  },
];

export const HeadWidthArr = [40, 216, 216, 120, 120];
export const fourContentWidth = [178, 178, 178, 178];
export const sixContentWidth = [40, 216, 108, 108, 120, 120];
export const sevenContentWidth = [40, 216, 48, 84, 84, 120, 120];
export const sevenHeadWidthArr = [58, 79, 128, 128, 128, 128, 62];
export const Detail3TableHead = ['전체목록', '면적', '감정가합계', '매각'];
export const Detail6TableHead = [
  '구분',
  '지번',
  '용도/구조/면적/토지이용계획',
  '감정가',
  '비고',
];
export const sevenTableHead = [
  '구분',
  '접수일',
  '권리종류',
  '권리자',
  '채권금액',
  '비고',
  '소멸여부',
];

export interface RealDealFilter {
  iidx: number;
  b_idx: number;
  distance: number;
  limit: number;
  offset: number;
}

export interface AroundRealDealFilter {
  iidx: number;
  b_idx: number;
  distance: number;
  limit: number;
  offset: number;
}

export const MapItemTypeData = [
  {
    name: '토지',
    value: 'A1',
    markerImg: '/assets/images/marker/land.svg',
  },
  {
    name: '아파트',
    value: 'A2',
    markerImg: '/assets/images/marker/apartment.svg',
  },
  {
    name: '오피스텔',
    value: 'A3',
    markerImg: '/assets/images/marker/officetel.svg',
  },
  {
    name: '다세대(빌라)/연립',
    value: 'A4',
    markerImg: '/assets/images/marker/townhouse.svg',
  },
  {
    name: '단독',
    value: 'A5',
    markerImg: '/assets/images/marker/detachedHouse.svg',
  },
  {
    name: '다가구',
    value: 'A6',
    markerImg: '/assets/images/marker/detachedHouse.svg',
  },
  {
    name: '빌딩',
    value: 'A7',
    markerImg: '/assets/images/marker/building.svg',
  },
  {
    name: '공장',
    value: 'B1',
    markerImg: '/assets/images/marker/factory.svg',
  },
  {
    name: '상가',
    value: 'B2',
    markerImg: '/assets/images/marker/downtown.svg',
  },
  {
    name: '주차장',
    value: 'B3',
    markerImg: '/assets/images/marker/parking.svg',
  },
  {
    name: '창고',
    value: 'B4',
    markerImg: '/assets/images/marker/factory.svg',
  },
  {
    name: '기타',
    value: 'C1',
    markerImg: '/assets/images/marker/etc.svg',
  },
];

export const ANavInfo = [
  '소재지',
  '물건 기본정보',
  '매각 정보',
  '물건현황',
  '감정가',
  '임차인현황',
  '등기부현황',
  '권리분석 체크 리스트',
  '예상 배당표',
  '경매집행비용',
  '가격분석',
  '매각통계',
];

export const PNavInfo = [
  '소재지',
  '물건 기본정보',
  '입찰 이력정보',
  '입찰 방법 및 입찰 제한 정보',
  '낙찰 후 인도/인수 책임',
  '입찰정보',
  '물건현황',
  '감정가',
  '임차인현황',
  '등기부현황',
  '가격분석',
];

export const NNaviInfo = [
  'NPL 분석요약',
  '채권내 물건별 개요',
  '부동산 현황',
  '매각기일 시뮬레이션',
  '선순위 내역',
  '예상 대출원리금',
  '예상 투자기간',
  '예상 배당분석',
  '비용 분석',
  '수익 분석',
];

export const ENaviInfo = ['예정물건정보', '당사자내역', '물건현황', '가격분석'];